import { render } from "./FormPassword.vue?vue&type=template&id=b329be50"
import script from "./FormPassword.vue?vue&type=script&lang=js"
export * from "./FormPassword.vue?vue&type=script&lang=js"

import "./FormPassword.vue?vue&type=style&index=0&id=b329be50&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/FormPassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b329be50"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b329be50', __exports__)) {
    api.reload('b329be50', __exports__)
  }
  
  module.hot.accept("./FormPassword.vue?vue&type=template&id=b329be50", () => {
    api.rerender('b329be50', render)
  })

}


export default __exports__